'use client';

import React from 'react';

import { Stack, Box, Heading } from '@chakra-ui/react';

import { CustomText } from '@components/Custom-text';

import ContactCard from '../cards/ContactCards';
import ContactForm from '../form/ContactForm';

export const ContactView = () => (
    <>
        <Box py={{ base: 6, md: 20 }}>
            <Stack spacing={4} alignItems="Center">
                <Heading color="primary.dark" size="2xl">
                    {' '}
                    We are Here to Help
                </Heading>
                <CustomText color="shadowSlate" size="md" textAlign="center">
                    {' '}
                    Have questions, ideas, or just want to chat? We are all ears!
                </CustomText>
            </Stack>
        </Box>
        <ContactCard />
        <hr />
        <ContactForm />
    </>
);
